import { useEffect } from "react";
import { ErrorType } from "./Types/ErrorType.ts";

export default function ErrorPage({ errorType, bookInfo }: { errorType: ErrorType; bookInfo: any }) {
  useEffect(() => {
    if (errorType === ErrorType.AlreadyPurchased) {
      const bookUrl =
        process.env.REACT_APP_ENVIRONMENT === "production"
          ? "https://lovdata.no/pro/#document/KARNOV/" + bookInfo.BookId
          : "https://stage.lovdata.no:8087/pro/#document/KARNOV/" + bookInfo.BookId;

      setTimeout(() => {
        window.location.href = bookUrl;
      }, 5000); // Redirect after 5 seconds
    }
  }, [errorType, bookInfo]);

  const getErrorMessage = (errorType: ErrorType) => {
    switch (errorType) {
      case ErrorType.AlreadyPurchased:
        return (
          <>
            Du har allerede kjøpt {bookInfo?.title ? bookInfo.title : "denne boken"}. Du blir omdirigert til boksiden på Lovdata
            om noen sekunder.
            <br />
            <br />
            Hvis du ikke blir omdirigert, vennligst klikk{" "}
            <a
              href={
                process.env.REACT_APP_ENVIRONMENT === "production"
                  ? "https://lovdata.no/pro/#document/KARNOV/" + bookInfo.BookId
                  : "https://stage.lovdata.no:8087/pro/#document/KARNOV/" + bookInfo.BookId
              }
            >
              her
            </a>
            .
          </>
        );
      case ErrorType.BookIdNotFound:
        return "Det finnes ingen bookId i nettadressen du forsøkte å åpne. Vennligst prøv igjen, og kontakt kundestøtte hvis problemet vedvarer.";
      case ErrorType.NoMetadataForBook:
        return "Det finnes ingen bok med denne ID-en i nettadressen. Vennligst prøv igjen, og kontakt kundestøtte hvis problemet vedvarer.";
      case ErrorType.TransactionIdNotFound:
        return "Det finnes ingen transactionId i nettadressen du forsøkte å åpne. Vennligst prøv igjen, og kontakt kundestøtte hvis problemet vedvarer.";
      case ErrorType.LovdataUserIdNotFound:
        return "Det finnes ingen userId i nettadressen du forsøkte å åpne. Vennligst prøv igjen, og kontakt kundestøtte hvis problemet vedvarer.";
      case ErrorType.LovdataUserIdNotActive:
        return "Denne brukeren er ikke aktiv i Lovdata. Vennligst prøv igjen, og kontakt kundestøtte hvis problemet vedvarer.";
      case ErrorType.LovdataAPICallError:
        return "Det oppstod en feil med Lovdata. Vennligst prøv igjen.";
      case ErrorType.NotGettingRedirectUrlFromVipps:
        return "Det oppstod en feil med Vipps. Vennligst prøv igjen.";
      case ErrorType.VippsAPICallError:
        return "Det oppstod en feil med Vipps. Vennligst prøv igjen.";
      default:
        return "Det oppstod en feil. Vennligst prøv igjen.";
    }
  };

  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h1>{errorType === "AlreadyPurchased" ? "Allerede kjøpt!" : "Error!"}</h1>
      <p>{getErrorMessage(errorType)}</p>
    </div>
  );
}
